import { Content, Root, Trigger } from '@radix-ui/react-collapsible';
import clsx from 'clsx';
import type { ComponentProps, ComponentPropsWithRef, FunctionComponent, ReactNode } from 'react';

export type CollapsibleProps = ComponentPropsWithRef<typeof Root>;

export type CollapsibleTriggerProps = {
    readonly asChild?: boolean;
    readonly children: ReactNode;
    readonly className?: string;
};

export type CollapsibleContentProps = {
    readonly children: ReactNode;
    readonly className?: string;
};

const CollapsibleContent: FunctionComponent<ComponentProps<typeof Content>> = ({ className, ...props }) => (
    <Content
        className={clsx('data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out', className)}
        {...props}
    />
);

export const Collapsible: FunctionComponent<CollapsibleProps> & {
    Content: typeof CollapsibleContent;
    Root: typeof Root;
    Trigger: typeof Trigger;
} = ({ children, ...props }) => {
    return <Root {...props}>{children}</Root>;
};

Collapsible.Root = Root;
Collapsible.Trigger = Trigger;
Collapsible.Content = CollapsibleContent;
